import { render } from "./OrdersTable.vue?vue&type=template&id=7e5f19dc&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=7e5f19dc&lang=scss"
import "./OrdersTable.vue?vue&type=style&index=1&id=7e5f19dc&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5f19dc"]])

export default __exports__